import { Button } from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./sortable-table-header-styles";

export type SortableTableHeaderPropsType = {
  name: string;
  header: string;
  isAscending: boolean;
  sortingColumn: string;
  isSortable: boolean;
  onSortChanged: (name: string, isAscending: boolean) => void;
};

export const SortableTableHeader = ({
  header,
  isAscending = true,
  name,
  sortingColumn,
  isSortable,
  onSortChanged,
}: SortableTableHeaderPropsType) => {
  const handleSortClick = () => {
    onSortChanged(name, !isAscending);
  };
  const { t } = useTranslation();
  const classes = useStyles();
  const endIconComponent =
    sortingColumn == name ? isAscending ? <ArrowDropUp /> : <ArrowDropDown /> : null;
  return isSortable ? (
    <Button
      onClick={handleSortClick}
      endIcon={endIconComponent}
      aria-roledescription={t("aria_description_click_to_sort")}
      className={classes.btn}
    >
      {header}
    </Button>
  ) : (
    <>{header}</>
  );
};
